const CompanyRegistrationNumberValidation = (taxnumber) => {
  const pattern = "[0-9]{4}[/][0-9]{6}[/][0-9]{2}";

  var reIsValidLength = new RegExp(`^${pattern}$`);

  if (reIsValidLength.test(taxnumber)) {
    return true;
  }

  return false;
};

export default CompanyRegistrationNumberValidation;
